import * as R from 'ramda';

export const getInitialState = partyId => ({
  partyId,
  currency: 'USD',
  statementLanguage: 'en',
  policyList: {},
});

export const getCurrentPolicy = state =>
  R.pathOr([], [state.partyId], state.policyList);

const reducer = (state, action) => {
  switch (action.type) {
    case 'changePolicy':
      return {
        ...state,
        partyId: action.payload.nextPartyId,
      };
    case 'changeCurrency':
      return {
        ...state,
        currency: action.payload.selectedCurrency,
      };
    case 'updateStatementInfo':
      return {
        ...state,
        policyList: action.payload.policyList,
        statementLanguage: action.payload.statementLanguage,
      };
    default:
      throw new Error();
  }
};

export default reducer;
